import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { billingExplorerWidgetSetupCostsSelector } from "./billingExplorerWidgetSetupCostsSelector";

export const billingExplorerWidgetSetupAverageExistsSelector =
  createDraftSafeSelector([billingExplorerWidgetSetupCostsSelector], (data) => {
    return !!data?.average?.cost;
  });
